import { IAppState } from 'shared/common/state';

export function selectCallbackWidgetOfferInfo(state: IAppState) {
  return state.newbuildingBrokerCallbackWidget.offerInfo;
}
